import showToaster from '../../../../helpers/showToaster';
import { updatePassword } from '../../../../actions/shop/forgotPassword/updatePassword';

async function submit(values, dispatch) {
  if (values?.newPassword != values?.confirmPassword) showToaster({ messageId: 'mismatchPassword', toasterType: 'error' })
  else dispatch(updatePassword(values?.email, values?.newPassword, values?.token))
}

export default submit;